import { useCallback, useState } from 'react';

interface UseDeleteModalProps {
  isOpen: boolean;
  openModal: () => void;
  onModalClose: (isDeleteAborted: boolean) => void;
}

export const useDeleteModal = (onClose: () => void): UseDeleteModalProps => {
  const [isOpen, toggleOpen] = useState(false);

  const openModal = useCallback(() => {
    toggleOpen(true);
  }, []);

  const onModalClose = useCallback(
    (isDeleteAborted: boolean) => {
      toggleOpen(false);

      if (!isDeleteAborted) {
        onClose();
      }
    },
    [onClose],
  );

  return {
    isOpen,
    openModal,
    onModalClose,
  };
};
